import { render, staticRenderFns } from "./DashboardLink.vue?vue&type=template&id=30f3391a&scoped=true"
import script from "./DashboardLink.vue?vue&type=script&lang=js"
export * from "./DashboardLink.vue?vue&type=script&lang=js"
import style0 from "./DashboardLink.vue?vue&type=style&index=0&id=30f3391a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f3391a",
  null
  
)

export default component.exports